import PropTypes from 'prop-types';
import Cookies from 'js-cookie';

const PixelPurchaseHandler = function PixelPurchaseHandler(props) {
    // We can change this to AppealKey if we want to set it up for per appeal basis in the future.
    const { charitykey, baseUrl } = props;

    const urlParams = new URLSearchParams(window.location.search);
    const givingId = urlParams.get('giving_id') || '';
    const amount = urlParams.get('amount') || '';
    const email = urlParams.get('donor_email') || '';
    const phone = urlParams.get('custom_mobile') || urlParams.get('custom_phone') || ''; // need to review this but this NOT a required field.

    // send purchase event only if we have the required parameters
    // if not it most likely means the page has not been loaded after a successful donation,
    // thus no point in sending the event to the pixel.

    const cookies = Cookies.get('ge_fbpixel');

    if (cookies && amount && givingId && email) {
        const data = JSON.parse(cookies);
        const {
            fbp, fbc, context, testeventcode,
        } = data;

        const eventData = {
            FBP: fbp || '',
            FBC: fbc || '',
            CharityKey: charitykey,
            Email: email,
            Phone: phone || '',
            GivingId: givingId,
            Amount: amount,
            TestEventCode: testeventcode,
            Context: context,
        };

        const { host, protocol } = new URL(baseUrl);

        const httpOptions = {
            method: 'POST',
            body: JSON.stringify(eventData),
            headers: new Headers({ 'content-type': 'application/json' }),
        };

        // request to server endpoint
        // from the server fetch the pixelId and API secret
        // and then send the request to FB conversions API
        fetch(`${protocol}//${host}/api/pixel/purchase`, httpOptions);
    }

    return null;
};

PixelPurchaseHandler.propTypes = {
    charitykey: PropTypes.string.isRequired,
    baseUrl: PropTypes.string,
};

PixelPurchaseHandler.defaultProps = {
    baseUrl: window.location.href,
};

export default PixelPurchaseHandler;
